import classNames from "classnames"

import { CheckBox, RecordView } from "web/components"
import { useLayouts } from "web/hooks/data"

import placeholderImage from "web/images/placeholder.svg"

export default function ObjectCard({
  subjectType,
  data,
  photoUrl,
  onSelectionChanged,
  onItemClick,
  isSticky = false,
}) {
  const layouts = useLayouts({ subjectType })
  const layout = layouts.find((layout) => layout.name === "Summary")

  const hasPhotos = !!photoUrl

  const canSelect = typeof onSelectionChanged === "function"

  const cardContainerClasses = classNames(
    "relative h-96 box-border bg-white rounded overflow-hidden cursor-pointer shadow-md",
    {
      "shadow-lg shadow-primary-8": isSticky,
    }
  )
  const cardImageClasses = classNames(
    "cursor-pointer mb-2.5 w-full h-48 relative"
  )

  return (
    <div className={cardContainerClasses} onClick={onItemClick}>
      <div className={cardImageClasses}>
        <div className="absolute bottom-0 left-0 right-0 max-w-full truncate bg-gray-700/70 p-1.5 text-sm text-white">
          {data.name}
        </div>
        <img
          className="box-border h-full w-full rounded-t object-cover"
          draggable="false"
          alt={subjectType}
          src={hasPhotos ? photoUrl : placeholderImage}
        />
      </div>
      <div className="m-2.5">
        <RecordView data={data} fields={layout.fields} fieldLimit={6} />
      </div>
      {canSelect && (
        <div className="absolute right-2.5 top-2.5 grid h-5 w-5 place-content-center rounded-lg bg-white">
          <CheckBox
            value={{ value: data.selected || false }}
            onChange={() => {
              onSelectionChanged({ ...data, selected: !data.selected })
            }}
            showValueLabel={false}
          />
        </div>
      )}
    </div>
  )
}
